import {PureComponent} from 'react'
import connect from 'react-redux/lib/connect/connect'
import Clipboard from 'react-feather/dist/icons/clipboard.js'
import PhoneCall from 'react-feather/dist/icons/phone-call.js'
import SearchIcon from 'react-feather/dist/icons/search.js'

import Landing from '../Landing.jsx'
import mustBeLogged from '../../../components/Must/MustBeLogged.jsx'
import mustHaveAcceptedCGU from '../../../components/Must/MustHaveAcceptedCGU.jsx'
import Search from '../../../components/Landing/Search.jsx'
import References from '../../../components/References/References.jsx'

import {loadUniverseById} from '../../../components/UniverseLoader/actions.js'
import conf from '../../../conf.js'
import sharedConf from '../../../../shared/conf.js'

const searchDivItems = [
  {
    title: 'Définissons ensemble votre besoin',
    text: 'Tous issus des métiers adressés (Achats, RH, Finance), nos managers vous accompagnent dans la définition ' +
      'de votre besoin et <strong>recherchent pour vous</strong>.<br/> <br/>' +
      'Réservez un rendez-vous téléphonique de <strong>' +
      '15 minutes</strong> dans leurs agendas :',
    icon: <PhoneCall/>,
    linkCalendly: conf.calendly.do,
    linkText: 'Réserver un créneau',
  },
  {
    title: 'Vous savez exactement ce que vous cherchez ?',
    text: 'Donnez-nous vos critères de recherche en remplissant notre formulaire. <br/> <br/>' +
      'Nos équipes vous <strong>recontacterons dans les 48 heures</strong> afin de vous proposer des solutions ' +
      'adaptées à votre besoin.',
    icon: <Clipboard/>,
    link: 'drop-need',
    linkText: 'Déposer un besoin',
  },
  {
    title: 'Cherchez vous-même des profils',
    text: 'Accès direct à notre base consultants. Parcourez les profils publics. <br/> <br/>' +
      '<strong>Nos managers ont accès à plus de profils que ceux affichés </strong>' +
      '(certains consultants choisissent de rester invisibles).',
    icon: <SearchIcon/>,
    link: 'search',
    linkText: 'Je cherche un profil',
  }
]

class LandingCompanyConnected extends PureComponent {
  render() {
    return <Landing
      className="landing-company"
      metaDescription="Effectuez différentes actions depuis votre espace entreprise : déposez un besoin, consultez les profils disponibles ou rencontrez un manager."
      metaTitle="Entreprise - Votre espace personnel"
      showSidebarMenu={true}
    >
      <div className="bg-light">
        <Search title="Choisissez votre mode de recherche" items={searchDivItems}/>
      </div>

      <References className="container landing-company text-center py-5"/>
    </Landing>
  }
}

export default connect(
  state => ({
    userUniverses: state.currentUser?.user?.universes?.length ? state.currentUser?.user?.universes : [],
    userMainUniverseId: state.currentUser?.user?.mainUniverse ?? null,
    currentUniverseId: state.universe?.currentUniverse?.id ?? null
  }),
  (dispatch) => ({
    loadUniverseById: (universeId) => dispatch(loadUniverseById(universeId))
  })

)(mustBeLogged(mustHaveAcceptedCGU(LandingCompanyConnected), sharedConf.accountTypes.do))
